import { useMemo } from 'react';
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';
import {
  normalizeUpscHeroPagesResponse,
  UPSC_HERO_PAGES_CMS_API_PATH
} from '@api/fetchers/upscCurrentAffairs/heroPages';

export interface UpscHeroSession {
  mainHeading?: string;
  description?: string | null;
}

export interface UpscHeroPagesData {
  homeHeroSession?: UpscHeroSession;
  todayAnalysisHeroSession?: UpscHeroSession;
  quizHeroSession?: UpscHeroSession;
  calendarHeroSession?: UpscHeroSession;
  monthlyPdfHeroSession?: UpscHeroSession;
  dailyPdfHeroSession?: UpscHeroSession;
  monthlyClassesHeroSession?: UpscHeroSession;
  subjectWiseHeroSession?: UpscHeroSession;
  detailPageHeroSession?: UpscHeroSession;
}

export interface UseUpscCurrentAffairsHeroPagesReturn {
  heroPages: UpscHeroPagesData;
  isLoading: boolean;
  isError: boolean;
}

const useUpscCurrentAffairsHeroPages =
  (): UseUpscCurrentAffairsHeroPagesReturn => {
    const { data, isValidating, isError } = useFetch(
      UPSC_HERO_PAGES_CMS_API_PATH,
      { hostType: HOST_TYPE.CMS, useCamelCase: true }
    );

    const heroPages = useMemo(
      () => normalizeUpscHeroPagesResponse(data),
      [data]
    );

    return {
      heroPages,
      isLoading: !data && !isError && isValidating,
      isError: Boolean(isError)
    };
  };

export default useUpscCurrentAffairsHeroPages;
